// Import enumerations
import {
	Peril,
} from '@app/enumerations';
// Import api models.
import {
	PossibleBaseData,
	PossibleDeductible,
} from '@app/models/api';

export default class PossiblePeril extends PossibleBaseData<Peril> {

	public isEligible: boolean | null = null;
	public isDeprecated: boolean | null = null;
	public reasonsForIneligibility: string[] = [];
	public possibleDeductibles: PossibleDeductible[] = [];

	public constructor() {
		super();
	}
};